export const MosErrorUiDataErrorHeading = "hm0olb";
export const MosErrorUiDataFailedReasonAuthFailed = "delwbc";
export const MosErrorUiDataFailedReasonTimeout = "Pdf9eb";
export const MosErrorUiDataFailedReasonOther = "ydOuHd";
export const MosErrorUiDataRetryButtonTitle = "DHOKi";
export const MosErrorUiDataErrorImageAltText = "Q22Ngc";
export default {MosErrorUiDataErrorHeading,MosErrorUiDataFailedReasonAuthFailed,MosErrorUiDataFailedReasonTimeout,MosErrorUiDataFailedReasonOther,MosErrorUiDataRetryButtonTitle,MosErrorUiDataErrorImageAltText};